module.exports = __webpack_public_path__ + "static/img/3.06287de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/3.png
// module id = gwaB
// module chunks = 0